import { InteractionType } from "@azure/msal-browser";

export class PCodeConfig
{
	static azureAd: PCodeConfigAzureAd =
		{
			enabled: false,
			tenantId: '',
			clientId: '',
			graphApiUrl: 'https://graph.microsoft.com/v1.0/',
			interactionType: InteractionType.Popup
		}

	static vapid: PCodeConfigVapid =
		{
			publicKey: 'BHizkSp85qDkNe3OA_maTi-W3tO5aEPkwaCGDdMrKFyUFNUWM5cBo3ccF3aaQxo_PMheg1b71wixiqWe3YqYlkg'
		}
}

interface PCodeConfigAzureAd
{
	enabled: boolean;
	tenantId: string;
	clientId: string;
	graphApiUrl: string;
	interactionType: InteractionType
}
interface PCodeConfigVapid
{
	publicKey: string;
}